function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Firebase Realtime Database (7- Raw Icon, Light)");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Firebase-Realtime-Database-(7--Raw-Icon,-Light)",
  transform: "translate(-24.000000, -24.000000)"
}, React.createElement("polygon", {
  id: "Path",
  points: "0 0 192 0 192 192 0 192"
}), React.createElement("path", {
  d: "M24,120 L168,120 L168,152.016 C168,160.848 160.856,168 152.04,168 L39.96,168 C31.144,168 24,160.816 24,152.016 L24,120 Z M24,39.936 C24,31.136 31.144,24 39.96,24 L152.04,24 C160.856,24 168,31.2 168,39.936 L168,96.064 C168,104.864 160.856,112 152.04,112 L39.96,112 C31.144,112 24,104.8 24,96.064 L24,39.936 Z M40,40 L152,40 L152,64 L40,64 L40,40 Z M40,84.04 C40,81.8 41.712,80 44.04,80 L51.96,80 C54.2,80 56,81.712 56,84.04 L56,91.96 C56,94.2 54.288,96 51.96,96 L44.04,96 C41.8,96 40,94.288 40,91.96 L40,84.04 Z M40,140.04 C40,137.8 41.712,136 44.04,136 L51.96,136 C54.2,136 56,137.712 56,140.04 L56,147.96 C56,150.2 54.288,152 51.96,152 L44.04,152 C41.8,152 40,150.288 40,147.96 L40,140.04 Z",
  id: "Shape",
  fill: "#FFFFFF"
})));

var SvgFirebaseRealtimeDatabase = function SvgFirebaseRealtimeDatabase(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "144px",
    height: "144px",
    viewBox: "0 0 144 144",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFirebaseRealtimeDatabase, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/firebase-realtime-database.79bb1651.svg";
export { ForwardRef as ReactComponent };